export default {
  'publish_date': 'Target Date',
  'page_type': 'Page Type',
  'url_status': 'URL Status',
  'content_brief_status': 'Brief Status',
  'is_optimized': 'URL Optimized',
  'section_name': 'Section',
  'url': 'Mapped URL',
  'published_url': 'Published URL',
  'link_count': 'Links',
  'keyword_count': 'KW Count',
  'msv_1_total': 'MSV 1',
  'msv_2_total': 'MSV 2',
  'msv_3_total': 'MSV 3',
  'msv_4_total': 'MSV 4',
  'keyword_score_average': 'Average Rel Score',
  'url_attribute': 'URL Attributes',
  'writing_status': 'Writing Status',
  'assigned_writer': 'Writer',
  'assigned_strategist': 'Strategist',
  'http_response_code': 'Response Code',
  'http_response_url': 'Resolving URL'
}
